import { useThemeContext } from '../Theme/providers/ThemeContextProvider';
import { useTranslationsContext } from '../Translations/providers/TranslationsContextProvider';
import SessionIcon from '../../app/assets/icons/session.svg?react';
import { useIsMobile } from '../../app/hooks/useIsMobile';
import { Modal } from '../../app/components/Modal/Modal';
import { SheetModal } from '../../app/components/SheetModal/SheetModal';
import { SheetModalHeader } from '../../app/components/SheetModal/SheetModalHeader';
import { useParticipantInfo } from './hooks/useParticipantInfo';

export interface ParticipantInfoModalProps {
	show?: boolean;
	onClose?: () => void;
}

export function ParticipantInfoModal({
	show,
	onClose,
}: Readonly<ParticipantInfoModalProps>) {
	const { subject } = useParticipantInfo();
	const { t } = useTranslationsContext();

	const theme = useThemeContext();
	const isMobile = useIsMobile();

	const content = () => {
		return (
			<>
				{subject}
			</>
		);
	};

	return (
		<>
			{isMobile && (
				<SheetModal
					isOpen={show}
					header={
						<SheetModalHeader
							prepend={
								<SessionIcon fill={theme.colors.brand.primary[300]} width={25} height={25} />
							}
							title={t('participant_info.subject_long')}
						/>
					}
					onClose={onClose}
				>
					{content()}
				</SheetModal>
			)}
			{!isMobile && (
				<Modal
					show={show}
					onClose={onClose}
					title={t('participant_info.subject_long')}
					$fitToChildren={true}
					prepend={
						<SessionIcon
							fill={theme.colors.brand.primary[300]}
							width={25}
							height={25}
						></SessionIcon>
					}
				>
					{content()}
				</Modal>
			)}
		</>
	);
}
